import React from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import { useDebriefModal } from 'ff/debrief/modalManager';

const ImportsButton = () => {
    const { open: openImports } = useDebriefModal('Imports');
    const handleClick = () => {
        openImports();
    };

    return <StyledButton onClick={handleClick}>Import</StyledButton>;
};

const StyledButton = styled(Button)`
    background-color: #203040;
    color: white;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 0.8rem;
    font-weight: bold;
`;

export default ImportsButton;
